import React from 'react';
import PropTypes from 'prop-types';

import BrandLogo from 'learn-common-brandlogo';
import Subtitle from 'learn-common-subtitle';

import styles from './Header.scss';

export const Header = ({ brandName, brandUrl, children, headerTitle }) => (
  <header className="d-flex col-12 col-lg-6 justify-content-center cancel-all-padding-margin">
    <hgroup className={`${styles.header} text-lg-center text-white bg--mobileheader fadeInLeft mx-0 mx-lg-4`}>
      <BrandLogo brandName={brandName} brandUrl={brandUrl} />
      <Subtitle headerTitle={headerTitle} />
      {children}
    </hgroup>
  </header>
);

Header.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  brandName: PropTypes.string,
  brandUrl: PropTypes.string,
  children: PropTypes.node
};

Header.defaultProps = {
  brandName: '',
  brandUrl: '',
  children: null
};

export default Header;
